import React from 'react';
import { cn } from '../../lib/cn';

export function Card({ hover = false, className, ...rest }) {
  return (
    <div
      className={cn(
        'bg-white border border-slate-200 rounded-xl shadow-soft',
        hover && 'transition-shadow duration-150 hover:shadow-lift',
        className
      )}
      {...rest}
    />
  );
}

export function CardHeader({ className, ...rest }) {
  return <div className={cn('px-5 pt-5 pb-3 flex items-start justify-between gap-3', className)} {...rest} />;
}

export function CardTitle({ className, ...rest }) {
  return <h3 className={cn('text-[15px] font-semibold text-slate-900 leading-tight', className)} {...rest} />;
}

export function CardDescription({ className, ...rest }) {
  return <p className={cn('text-[13px] text-slate-500 mt-1', className)} {...rest} />;
}

export function CardContent({ className, ...rest }) {
  return <div className={cn('px-5 py-4', className)} {...rest} />;
}

export function CardFooter({ className, ...rest }) {
  return <div className={cn('px-5 py-3 border-t border-slate-100 bg-slate-50/60 rounded-b-xl flex items-center gap-2', className)} {...rest} />;
}
